import { createNumberFormatter, partsToString, safeFormatParts } from "./core";

const powerFormatter = createNumberFormatter(1);
const energyFormatter = createNumberFormatter(1);
const irradianceFormatter = createNumberFormatter(0);
const temperatureFormatter = createNumberFormatter(0);

export function formatPowerParts(val: number | null) {
  return safeFormatParts(val, powerFormatter, "MW");
}

export function formatPower(val: number | null) {
  const parts = formatPowerParts(val);
  return partsToString(parts);
}

export function formatEnergyParts(val: number | null) {
  return safeFormatParts(val, energyFormatter, "MWh");
}

export function formatGeneration(val: number | null) {
  const parts = formatEnergyParts(val);
  return partsToString(parts);
}

export function formatIrradianceParts(val: number | null) {
  return safeFormatParts(val, irradianceFormatter, "W/m²");
}

export function formatIrradiance(val: number | null) {
  const parts = formatIrradianceParts(val);
  return partsToString(parts);
}

export function formatTemperatureParts(val: number | null) {
  return safeFormatParts(val, temperatureFormatter, "°C");
}

export function formatTemperature(val: number | null) {
  const parts = formatTemperatureParts(val);
  return partsToString(parts);
}
